export default __webpack_public_path__ + "static/carousel3-6d41c1f3a11aee9519f78c0f7e3159c5.png";